import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter as Router } from 'react-router-dom';
import { Button } from '@/components/Elements';
import { Notifications } from '@/components/Notifications/Notifications';
import { AuthProvider, useAuth } from '@/lib/auth';
import { queryClient } from '@/lib/react-query';
import storage from '@/utils/storage';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GOOGLE_CLIENT_ID, APP_PATH, SCOPE } from '@/config';

import appLoading from '@/assets/animation/loading.json';
import Lottie from 'lottie-react';
const ErrorFallback = (a: any, b: any) => {
  // console.log('======>>>', a.error.message, a);

  if (a.error.message.indexOf('status code 401') >= 0) {
    storage.clearToken();
    window.location.assign((window.location.origin + APP_PATH) as unknown as string);
  }
  return (
    <div
      className="text-red-500 w-screen h-screen flex flex-col justify-center items-center"
      role="alert"
    >
      <h2 className="text-lg font-semibold">Ooops, something went wrong :( </h2>
      <Button
        className="mt-4"
        onClick={() => window.location.assign(window.location.origin + APP_PATH)}
      >
        Refresh
      </Button>
    </div>
  );
};

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <React.Suspense
      fallback={
        <div className="flex items-center justify-center w-screen h-screen">
        <Lottie className="loading-loader-class" animationData={appLoading} />
        </div>
      }
    >
      <ErrorBoundary FallbackComponent={ErrorFallback}>
          <HelmetProvider>
            <QueryClientProvider client={queryClient}>
              {process.env.NODE_ENV !== 'test' && <ReactQueryDevtools />}
              <Notifications />
              <AuthProvider>
                <Router basename={APP_PATH}>{children}</Router>
                <ToastContainer autoClose={2000} />
              </AuthProvider>
            </QueryClientProvider>
          </HelmetProvider>
      </ErrorBoundary>
    </React.Suspense>
  );
};
